const InviteCardSkeleton = () => {
  return (
    <div className="flex w-full items-center gap-3 py-2">
      <div className="size-11 animate-pulse rounded-full bg-muted"></div>
      <div className="flex min-w-0 flex-col gap-2">
        <div className="h-5 w-32 animate-pulse rounded bg-muted"></div>
        <div className="h-4 w-24 animate-pulse rounded bg-muted"></div>
      </div>
    </div>
  )
}

export default InviteCardSkeleton
